export const DEFAULT_LIST_LIMIT = 30;
export const RECENT_ANALYSIS_LIMIT = 20;
